import { CheckOption } from "@/components/we360/CheckOption";
import { AutocompleteInput } from "@/components/we360/AutocompleteInput";
import { CONDICIONES_LIST } from "@/data/condiciones";
import { PREDEFINED_CONDITIONS } from "@/data/loinc";
import { X } from "lucide-react";

export default function Step4History({ data, setField, autoDetected, toggleCondition }) {
  const condicionesAdicionales = data.condicionesAdicionales || [];

  const addCondicion = (item) => {
    if (condicionesAdicionales.some((c) => c.nombre === item.nombre)) return;
    const entry = {
      nombre: item.nombre,
      codigoCIE10: item.codigoCIE10,
      codigoSNOMED: item.codigoSNOMED,
      source: "curated",
    };
    setField("condicionesAdicionales", [...condicionesAdicionales, entry]);
  };

  const addCondicionLibre = (text) => {
    if (condicionesAdicionales.some((c) => c.nombre.toLowerCase() === text.toLowerCase())) return;
    const entry = {
      nombre: text,
      codigoCIE10: null,
      codigoSNOMED: null,
      source: "free_text",
    };
    setField("condicionesAdicionales", [...condicionesAdicionales, entry]);
  };

  const removeCondicion = (index) => {
    setField("condicionesAdicionales", condicionesAdicionales.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div className="text-center mb-4">
        <p
          className="text-sm text-[#71644C] max-w-[340px] mx-auto leading-relaxed"
          data-testid="step4-instructions"
        >
          Selecciona tus antecedentes médicos. Algunas condiciones se <strong className="text-[#00628F] font-semibold">auto-detectan</strong> a partir de tus mediciones clínicas.
        </p>
      </div>

      <div className="glass-card p-5 rounded-3xl mb-5 text-left border border-white/40 shadow-sm space-y-2.5">
        <h3 className="text-xs font-bold uppercase tracking-wider text-[#00628F] mb-3">
          Historial Médico
        </h3>
        
        {PREDEFINED_CONDITIONS.map((cond) => {
          const isAutoDetected = autoDetected.includes(cond.id);
          const isChecked = data.condicionIds?.includes(cond.id) || isAutoDetected;
          return (
            <CheckOption
              key={cond.id}
              label={cond.nombre}
              checked={isChecked}
              onChange={() => { if (!isAutoDetected) toggleCondition(cond.id); }}
              disabled={isAutoDetected}
              tag={isAutoDetected ? "detectado" : null}
              testId={`check-${cond.id}`}
            />
          );
        })}
      </div>

      <div className="glass-card p-5 rounded-3xl text-left border border-white/40 shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-[#00628F] mb-4">
          Otras Condiciones
        </h3>

        <AutocompleteInput
          label="Buscar diagnóstico (CIE-10 / SNOMED)"
          list={CONDICIONES_LIST}
          displayField="nombre"
          subtextField="categoria"
          onSelect={addCondicion}
          onFreeText={addCondicionLibre}
          placeholder="Ej: hipotiroidismo, asma..."
          allowFreeText={true}
          testId="autocomplete-condiciones"
        />

        {condicionesAdicionales.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-4" data-testid="condiciones-chips">
            {condicionesAdicionales.map((cond, idx) => (
              <div
                key={idx}
                className="flex items-center gap-2 px-3 py-1.5 rounded-full transition-all shadow-sm"
                style={{
                  background: cond.source === "curated" ? "#E3F0F5" : "#FAF8F0",
                  border: `1px solid ${cond.source === "curated" ? "rgba(0,98,143,0.15)" : "#E2D9CB"}`,
                }}
                title={
                  cond.source === "curated"
                    ? `CIE-10: ${cond.codigoCIE10} · SNOMED: ${cond.codigoSNOMED}`
                    : undefined
                }
                data-testid={`condicion-chip-${idx}`}
              >
                <span className="text-xs font-semibold text-[#2D2A24]">
                  {cond.nombre}
                </span>
                {cond.source === "free_text" && (
                  <span className="text-[9px] font-bold text-[#B5A998] bg-[#E2D9CB]/20 px-1.5 py-0.5 rounded">(Texto libre)</span>
                )}
                <button
                  onClick={() => removeCondicion(idx)}
                  className="ml-1 p-0.5 rounded-full hover:bg-black/5 transition-colors cursor-pointer"
                  style={{ background: "transparent", border: "none" }}
                  type="button"
                  data-testid={`condicion-remove-${idx}`}
                >
                  <X size={12} className="text-[#71644C]" />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
